/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakesempty1Inputs */

const zh_learn_mistakesempty1 = /** @type {(inputs: Learn_Mistakesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有错题，继续学习吧！`)
};

const en_learn_mistakesempty1 = /** @type {(inputs: Learn_Mistakesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No mistakes yet. Keep studying!`)
};

const es_learn_mistakesempty1 = /** @type {(inputs: Learn_Mistakesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Aún no hay errores! ¡Sigue estudiando!`)
};

/**
* | output |
* | --- |
* | "No mistakes yet. Keep studying!" |
*
* @param {Learn_Mistakesempty1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakesempty1 = /** @type {((inputs?: Learn_Mistakesempty1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakesempty1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakesempty1(inputs)
	if (locale === "en") return en_learn_mistakesempty1(inputs)
	return es_learn_mistakesempty1(inputs)
});
export { learn_mistakesempty1 as "learn_mistakesEmpty" }